<template>
  <div class="doc-requisites">
    <p>SOFTEKA - FZCO</p>
    <p>TRN 104812137800001</p>
    <p>Лицензия 55022</p>
    <p>Юридический адрес: IFZA Business Park, DDP, PO Box 342001, Dubai, United Arab Emirates</p>
    <p>Адрес: IFZA Business Park, Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, UAE</p>
    <p>Регулирующий орган: International Free Zone Authority (IFZA), Dubai</p>
    <p>
      Адрес электронной почты:
      <a href="mailto:support@myconnectapp.ru">support@myconnectapp.ru</a>
      Веб-сайт:
      <a href="https://myproxy7.com/">https://myproxy7.com</a>
    </p>
  </div>
</template>
